// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_AccountManagement from "../Ouroboros.Programs.Controllers.AccountManagement/index.js";
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var buildAccountManagementViewProps = function (input) {
    return {
        accountDetails: readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.accountDetails)),
        membership: readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.membership)),
        passwordStep: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.passwordStep)),
        passwordResetCompleted: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.passwordResetCompleted)),
        passwordSubmitting: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.passwordSubmitting)),
        onPasswordStepChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.passwordStep))(value);
        },
        onPasswordResetCompletedChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.passwordResetCompleted))(value);
        },
        onRequestPasswordReset: Ouroboros_Programs_Controllers_AccountManagement.onRequestPasswordReset(input.kernel),
        onCompletePasswordReset: Ouroboros_Programs_Controllers_AccountManagement.onCompletePasswordReset(input.kernel),
        onInit: Ouroboros_Programs_Controllers_AccountManagement.buildOnInit(input.kernel)
    };
};
export {
    buildAccountManagementViewProps
};
//# sourceMappingURL=index.js.map
